import request from '@/utils/request'

// 조회
export function getRiskAssessmentMeasuresReductionList (params, isProgress) {
  return request({
    url: `/api/getRiskAssessmentMeasuresReductionList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}

// 조회
export function getRiskAssessmentMeasuresReductionCode (params, isProgress) {
  return request({
    url: `/api/getRiskAssessmentMeasuresReductionCode`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}

// 조회
export function getRiskAssessmentMeasuresReductionPerson (params, isProgress) {
  return request({
    url: `/api/getRiskAssessmentMeasuresReductionPerson`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}

export function saveRiskAssessmentMeasuresReduction (params, isProgress) {
  return request({
    url: `/api/saveRiskAssessmentMeasuresReduction`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'saved' },
  })
}

// 출력
export function getRptRiskAssessmentMeasuresReduction (params) {
  // html 이미지 출력 문제로 보류
  // let responseType = params.type !== "html" ? "blob" : "stream"
  let responseType = "blob"
  return request({
    url: '/api/getRptRiskAssessmentMeasuresReduction',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    responseType: responseType
  })
}

export function getRptRiskAssessmentMeasuresReductionList (params) {
  // html 이미지 출력 문제로 보류
  // let responseType = params.type !== "html" ? "blob" : "stream"
  let responseType = "blob"
  return request({
    url: '/api/getRptRiskAssessmentMeasuresReductionList',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    responseType: responseType
  })
}